var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QuestionSlider"},[_c('LLRangeSlider',{attrs:{"value":_vm.value,"disabled":_vm.locked,"min":_vm.min,"str-max":_vm.strMax,"str-min":_vm.strMin,"max":_vm.max},on:{"input":_vm.onInput,"update:interacted":_vm.onInteracted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }